module.exports = "<svg id=\"05e8569f-450b-4c94-88be-18da20fb0ca2\" data-name=\"30240588-69cc-4f38-83e3-24c9deb56a02\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.15 49.29\"><title>LeftArrow</title><path d=\"M22.56,44.58,8.93,27.51H9L6.66,24.6,9,21.71H8.93l13.64-17A3.08,3.08,0,0,0,22.12.63,2.91,2.91,0,0,0,18,1.08L.64,22.83A2.65,2.65,0,0,0,0,24.64H0a4.28,4.28,0,0,0,.63,1.81L18,48.2a2.92,2.92,0,0,0,4.08.45A3,3,0,0,0,22.56,44.58Z\" transform=\"translate(0 0)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/LeftArrow.svg
// module id = Ruwq
// module chunks = 1